import React, {useEffect, useState} from 'react';
import * as S from './PartnerAdvantage.styles';
import IconSelector from '@ibibo/icon-selector';

import WalletDwebImg from './assets/dweb/wallet-dweb.png';
import WalletMwebImg from './assets/mobile/wallet-mobile.png';
import WalletDwebGcc from './assets/dweb/wallet-dweb-gcc.png';

const PartnerAdvantage = ({timeZone}) => {
  const deviceWidth = typeof window === 'undefined' ? 100 : window.screen.width;
  // let blockType = false;
  const [blockType, setBlockType] = useState(false);
  useEffect(() => {
    if (deviceWidth > 1023) {
      setBlockType(true);
    }
  }, []);

  return (
    <S.PartnerAdvantageMainWrap id="advantage">
      <S.PartnerAdvantageInnerWrap>
        <S.WhyPartnerHeadWrap>
          <S.WhyPartnerHeadText>myPartner Advantages</S.WhyPartnerHeadText>
          <S.WhyPartnerSubText>It is a feature loaded platform!</S.WhyPartnerSubText>
        </S.WhyPartnerHeadWrap>
        {(blockType && (
          <>
            <S.ImageBackOval />
            <S.PartnerAdvantageWrap>
              <S.AdvantageTileWrap>
                <S.AdvantageTile props={{active: true}}>
                  <S.TileIconWrap>
                    <IconSelector iconKey="easyAccessNew" />
                  </S.TileIconWrap>
                  <S.TileTextWrap>
                    <S.TileText>Get easy access to booking and payment records</S.TileText>
                  </S.TileTextWrap>
                </S.AdvantageTile>
                <S.AdvantageTile>
                  <S.TileIconWrap>
                    <IconSelector iconKey="easyBookingNew" />
                  </S.TileIconWrap>
                  <S.TileTextWrap>
                    <S.TileText>Manage easy post-booking modifications on flights</S.TileText>
                  </S.TileTextWrap>
                </S.AdvantageTile>
                {!timeZone && (
                  <S.AdvantageTile>
                    <S.TileIconWrap>
                      <IconSelector iconKey="safeHygenicNew" />
                    </S.TileIconWrap>
                    <S.TileTextWrap>
                      <S.TileText>
                        Safe and hygienic stays with MySafety compliant properties
                      </S.TileText>
                    </S.TileTextWrap>
                  </S.AdvantageTile>
                )}
                {!timeZone && (
                  <S.AdvantageTile>
                    <S.TileIconWrap>
                      <IconSelector iconKey="cancelPolicyNew" />
                    </S.TileIconWrap>
                    <S.TileTextWrap>
                      <S.TileText>
                        Enjoy the best-in-class cancellation policies on hotels
                      </S.TileText>
                    </S.TileTextWrap>
                  </S.AdvantageTile>
                )}
                <S.AdvantageTile>
                  <S.TileIconWrap>
                    <IconSelector iconKey="shareWhatsappNew" />
                  </S.TileIconWrap>
                  <S.TileTextWrap>
                    <S.TileText>Share options directly with your audience on WhatsApp</S.TileText>
                  </S.TileTextWrap>
                </S.AdvantageTile>
                <S.AdvantageTile>
                  <S.TileIconWrap>
                    <IconSelector iconKey="confirmationPrintNew" />
                  </S.TileIconWrap>
                  <S.TileTextWrap>
                    <S.TileText>
                      Get booking confirmations printed under your agency’s logo
                    </S.TileText>
                  </S.TileTextWrap>
                </S.AdvantageTile>
              </S.AdvantageTileWrap>
              <S.AdvantageImageWrap>
                <S.AdvantageImage
                  src={
                    timeZone && blockType
                      ? 'https://assets-gos3.goibibo.com/myp_WalletAED_3-1678350711.png'
                      : WalletDwebImg
                  }
                  alt="wallet info"
                />
              </S.AdvantageImageWrap>
            </S.PartnerAdvantageWrap>
          </>
        )) || (
          <S.MobileViewTag>
            {!timeZone && (
              <S.AdvantageMobileImgWrap>
                <S.AdvantageImage
                  src={'https://assets-gos3.goibibo.com/myp_home_page_partner-1698734466.png'}
                  alt="wallet info"
                />
              </S.AdvantageMobileImgWrap>
            )}
            <S.AdvantageTileWrapMobile>
              <S.AdvantageTileMobileInner>
                <S.MobileTileWrap>
                  <S.MobileTileIconWrap>
                    <IconSelector iconKey="easyAccessNew" />
                  </S.MobileTileIconWrap>
                  <S.MobileTileTextWrap>
                    <S.MobileTileText>Easy access to booking and payment records</S.MobileTileText>
                  </S.MobileTileTextWrap>
                </S.MobileTileWrap>
                <S.MobileTileWrap>
                  <S.MobileTileIconWrap>
                    <IconSelector iconKey="easyBookingNew" />
                  </S.MobileTileIconWrap>
                  <S.MobileTileTextWrap>
                    <S.MobileTileText>Easy and quick post booking modifications</S.MobileTileText>
                  </S.MobileTileTextWrap>
                </S.MobileTileWrap>
                <S.MobileTileWrap>
                  <S.MobileTileIconWrap>
                    <IconSelector iconKey="safeHygenicNew" />
                  </S.MobileTileIconWrap>
                  <S.MobileTileTextWrap>
                    <S.MobileTileText>
                      Safe and hygienic stays with MySafety compliant properties
                    </S.MobileTileText>
                  </S.MobileTileTextWrap>
                </S.MobileTileWrap>
                <S.MobileTileWrap>
                  <S.MobileTileIconWrap>
                    <IconSelector iconKey="cancelPolicyNew" />
                  </S.MobileTileIconWrap>
                  <S.MobileTileTextWrap>
                    <S.MobileTileText>Best-in-class cancellation policies</S.MobileTileText>
                  </S.MobileTileTextWrap>
                </S.MobileTileWrap>
                <S.MobileTileWrap>
                  <S.MobileTileIconWrap>
                    <IconSelector iconKey="shareWhatsappNew" />
                  </S.MobileTileIconWrap>
                  <S.MobileTileTextWrap>
                    <S.MobileTileText>
                      Share options directly with customers via WhatsApp
                    </S.MobileTileText>
                  </S.MobileTileTextWrap>
                </S.MobileTileWrap>
                <S.MobileTileWrap>
                  <S.MobileTileIconWrap>
                    <IconSelector iconKey="confirmationPrintNew" />
                  </S.MobileTileIconWrap>
                  <S.MobileTileTextWrap>
                    <S.MobileTileText>
                      Get booking confirmations printed under your agency’s logo
                    </S.MobileTileText>
                  </S.MobileTileTextWrap>
                </S.MobileTileWrap>
              </S.AdvantageTileMobileInner>
            </S.AdvantageTileWrapMobile>
          </S.MobileViewTag>
        )}
      </S.PartnerAdvantageInnerWrap>
    </S.PartnerAdvantageMainWrap>
  );
};

export default PartnerAdvantage;
